<template>
  <div class="modal overflow-auto" select-cy="update-supporter-details">
    <div class="card inner">
      <div class="header">
        <div class="title">
          <h2>Edit Payment Information</h2>
        </div>
        <div class="close" @click="close()">
          <i class="icn icn-x sm"></i>
        </div>
      </div>
      <div class="content">
        <form id="contacts-edit" @submit.prevent @submit="edit">
          <BamboraCreditCardForm
            style="padding-top: 24px"
            :show-button="false"
            @readyToSave="readyToSave"
            @notReady="notReady"
            @error="onError"
            @success="onSuccess"
          ></BamboraCreditCardForm>
        </form>
      </div>

      <!-- Error Messages -->
      <Alert v-if="errorMessage" :message="errorMessage"></Alert>

      <div class="footer">
        <button class="secondary" type="button" @click="close()">Cancel</button>
        <div class="flex-grow"></div>
        <button type="button" @click="edit()" :disabled="!canSubmit" select-cy="submit-edit-supporter">
          <span v-if="!isValidating">Save</span>
          <span class="icon" v-if="isValidating">
            <i class="icn icn-refresh sm animate-reverse-spin"></i>
          </span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { ALERT_TYPE, MESSAGES, CONTACT_TYPE } from '@/helpers/constants';
// import { ALERT_TYPE } from '@/helpers/constants';
import { MODAL_NAME } from '../../stores/supporters';
import Alert from '@/components/Alert.vue';
import BamboraCreditCardForm from '@/components/DonationModal/BamboraCreditCardForm.vue';

export default {
  name: 'SupporterEditPaymentDetails',
  components: {
    Alert,
    BamboraCreditCardForm,
  },

  data() {
    return {
      editItem: {
        cardHolderName: '',
        cardNumber: '',
        cardExpiry: '',
        cvv: '',
      },
      isValidating: false,
      canSubmit: false,
      message: null,
      token: null,
    };
  },
  props: {
    supporter: Object,
  },
  computed: {
    errorMessage: {
      get() {
        return this.message;
      },
      set(value) {
        if (value === null) {
          this.message = null;
        } else {
          this.message = {
            content: value,
            type: ALERT_TYPE.ERROR,
          };
        }
      },
    },
  },

  methods: {
    close() {
      this.$store.commit('supporters/close', MODAL_NAME.EDIT_PAYMENT);
    },
    readyToSave() {
      this.canSubmit = true;
    },
    notReady() {
      this.canSubmit = false;
    },
    onError() {
      this.errorMessage = 'Unable to process transaction. Please try again later.';
      this.canSubmit = true;
    },
    onSuccess({ token, cardHolderName }) {
      this.editItem.cardHolderName = cardHolderName;
      this.token = token;
    },
    edit() {
      if (this.isValidating) return;
      this.errorMessage = null;
      this.isValidating = true;
      const isValid = document.querySelector('#contacts-edit').reportValidity();
      if (isValid) {
        let email;
        if (this.supporter.contacts) {
          email = this.supporter.contacts
            .filter(contact => contact.type === CONTACT_TYPE.EMAIL)
            .sort((a, b) => (b.isPrimary ? 1 : -1))[0];
        }
        const payload = {
          supporterId: this.supporter.id,
          email: email ? email.contact : undefined,
          createdAt: new Date().toISOString(),
          private: {
            ResponseFromPP: {
              cardHolderName: this.editItem.cardHolderName,
            },
            checkoutdetails: {
              token: this.token,
            },
          },
        };
        console.log('payload', payload);

        this.$store
          .dispatch('supporters/createUpdateDetails', [payload])
          .then(() => {
            this.$store.dispatch('notifications/success', {
              headline: 'Payment Details Updated',
              details: 'The request has been submitted.',
            });
            this.close();
            this.$store.commit('supporters/refresh');
          })
          .catch(err => {
            console.error(err);
            if (err && err.status && err.status === 401) {
              this.errorMessage = MESSAGES.NO_PERMISSION;
            } else {
              this.errorMessage = MESSAGES.SERVER_ERROR;
            }
          })
          .finally(() => (this.isValidating = false));
      } else {
        this.isValidating = false;
      }
    },
  },
};
</script>
